import React,{useEffect, useState} from "react"
import { Navbar,Row,Modal,ModalBody,Container, } from "reactstrap"
import { connect } from "react-redux"
import classnames from "classnames"
import {toast} from 'react-toastify'
import {logoutWithJWT} from "@store/actions/auth/loginActions"
import { history } from "@src/history"
import {surrenderBattle} from '@store/actions/socket/socket_actions';
import NavbarUser from "../../../pvp/components/navbar/NavbarUser";
import NavbarNotifications from "../../../pvp/components/navbar/NavbarNotifications";

const soundClick ='/sounds/pvp_sounds/click.mp3';
const logoModal =  '/img/bg/logo_pvp_challenge.png'

const playClickEl = new Audio(soundClick)
function toggleFullscreen(elem) {
  elem = elem || document.documentElement;
  if (!document.fullscreenElement && !document.mozFullScreenElement &&
    !document.webkitFullscreenElement && !document.msFullscreenElement) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }
}
const ThemeNavbar  = props => {
  const colorsArr = [ "primary", "danger", "success", "info", "warning", "dark"];
  const navbarTypes = ["floating" , "static" , "sticky" , "hidden"];
  const [showModal, setShowModal] = useState(false);
  const [mute, setMute] = useState(localStorage.getItem("mute"));
const createRefLink=() => {
    navigator.clipboard.writeText(props?.socket_user?.wax_wallet)
  toast.success('Name copied to clipboard')
}
  useEffect(() => {
    if (!localStorage.getItem("mute")) {
      localStorage.setItem("mute","true")
    }
    const intervalMute = setInterval(() => {
          if (mute !== localStorage.getItem("mute")) {
            setMute(localStorage.getItem("mute"))
          }
    }, 0)
    return () => { clearInterval(intervalMute) }
  },[mute])



 const muteSounds = () => { localStorage.setItem("mute", localStorage.getItem('mute') === "true" ? false : true);}
 const playClick = () => {
   if (localStorage.getItem('mute') === "true") {
      playClickEl.volume = (Number(localStorage.getItem("sound")))
      playClickEl.play(playClickEl.currentTime = 0)
    }
 }
  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="pvp_navbar_wrap"><Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu",
          {
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) || (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "pvp": ['/pvp', '/pvp/friendly', '/pvp/tournaments', '/pvp/tournament_history','/pvp/tournament_active','/pvp/decks'].includes(window.location.pathname),
            "battle":window.location.pathname === '/pvp/battle',
            "tournament":['/pvp/tournaments','/pvp/tournament_history','/pvp/tournament_active'].includes(window.location.pathname),
            "space-station":['/shadow_depths'].includes(window.location.pathname)
          }
        )}
      >

      <div className="navbar-wrapper">
        </div>
      </Navbar></div>
        <NavbarUser
            userName={props.user.name}
            loggedInWith={
                props.user !== undefined
                    ? props.loggedInWith
                    : null
            }
        />

      <Modal size="xxl" isOpen={showModal} className="pvp-modal-finish">
        <ModalBody>
          <Container fluid >
              <Row className="container-lobby">

                <div className="username">
                  <div className="over_btn"></div>
                  <p>{props.user.userAccount}</p>
                </div>

              <div className="close_btn" style={{ position: 'absolute', right: '12px' }} onClick={() => { playClick(); setShowModal(false) }}>
                  <svg className="close_icon"><use href="/img/pvp_main_menu.svg#close_x"/></svg>
                  <svg className="close_icon medium"><use href="/img/pvp_main_menu.svg#close_x_small"/></svg>
                  <svg className="close_icon mobile"><use href="/img/pvp_main_menu.svg#close_x_mobile"/></svg>
                </div>

                <div className="pvp-modal-content">
                  <img className="pvp-modal-logo" src={logoModal} alt="logo" />
                  <h3 className="pvp-modal-text">Are you sure you want to leave the battle?</h3>
                </div>

                <div className='container-btn'>
                <button className="btn-no" onClick={() => { playClick(); setShowModal(false) }}><p>CANCEL</p></button>
                <button className="btn-yes" onClick={() => {
                          playClick()
                          props.surrenderBattle()
                          setShowModal(false)
                  }}><p>YES</p></button>
                </div>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
    return {
        user: state.authorizedUser.user,
        socket_user: state.socket.socket_user,
        socket_connected: state.socket.socket_connected,
      navbar_pvp_notifications: state.socket.friendly_lobby,
      mute:state
    }
}

export default connect(mapStateToProps, {logoutWithJWT, surrenderBattle})(ThemeNavbar)

